import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ToastrService } from 'ngx-toastr';
import { Message } from '../class/message';

@Injectable({
  providedIn: 'root'
})
export class MultiDownloadService {
  private data$ = new BehaviorSubject<DataDownload>({});
  public blocking = false;
  public open$ = new BehaviorSubject<boolean>(false);

  constructor(
    private toastr: ToastrService,
    private message: Message,
  ) {
  }

  connect() {
    return this.data$.asObservable();
  }

  setData(reqData: DataDownload) {
    this.blocking ? this.toastr.error(this.message.getMessage('messages.blocking_multi_download')) : this.data$.next(reqData);
  }

  clearData() {
    this.data$.next({});
  }

  setBlocking(status: boolean) {
    this.blocking = status;
  }

  get _open$() {
    return this.open$.asObservable();
  }

  setOpen(status = false) {
    this.open$.next(status);
  }
}

export class DataDownload {
  contractIds?: string[];
  menuContract?: string;
  isDigital?: boolean;
  employeeName?: string;
  employeeProfileCount?: number;
  laborContractName?: string;
  isLaborContractDownload?: boolean;
}
